import styles from './styles.module.scss'

import { useEffect, useRef, useState } from 'react'

import AuctionListing from '../AuctionListing/AuctionListing';

import { useSocket } from '../../../Context/socket';
import { useSession } from 'next-auth/react'

import { BarLoader, PuffLoader, PulseLoader } from 'react-spinners'
import errorMsg from '../../../Functions/errorMsg'
import axios from 'axios'
import LoadingSpinner from '../../LoadingSpinner/LoadingSpinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCancel, faCheck, faDollarSign, faEye, faMessage, faPaperPlane, faPencil, faPeopleArrows, faSquarePlus, faXmark } from '@fortawesome/free-solid-svg-icons';

import EditAuction from './EditAuction/EditAuction';

import { motion } from 'framer-motion';
import Image from 'next/image';

import CreateAuction from './CreateAuction/CreateAuction';
import { isEqual } from 'lodash';
import { useRouter } from 'next/router';
import successMsg from '../../../Functions/successMsg';

export default function Selling({ setPendingRequest }) {

  const { data: session, status } = useSession();

  const [initialLoading, setInitialLoading] = useState(null);
  const [myListings, setMyListings] = useState(null);

  useEffect(() => {
    if(initialLoading !== null) return;
    if(myListings !== null) return;
    if(status === 'loading') return;
    if(!session) return;

    async function getMyListings() {
        setInitialLoading(true);
        setPendingRequest(true);

        const result = await axios.post(`${window.location.origin}/api/auctionHub/getData`, {
          userID: session.user.token.id
        }).catch((error) => {
            errorMsg(error?.response?.data?.status || error.toString())
        })

        if(result && result.status === 200) {
          const data = result.data;
          setMyListings(data.userAuctions.sort(function(a, b) { return new Date(b.creationDate) - new Date(a.creationDate)}));
        }

        setPendingRequest(false);
    }

    getMyListings();

  }, [session, status, initialLoading, myListings])

  function isLoading() {
    if(status === 'loading') return true;
    if(initialLoading === false || initialLoading === null) return true;
    if(myListings === null) return true;
    return false;
  }

  const [viewAuctionData, setViewAuctionData] = useState(null); // ListingID stored
  const [editAuctionData, setEditAuctionData] = useState(null); // ListingID stored
  const [createAuction, setCreateAuction] = useState(false); // True / False for creating an auction

  function refreshListings() {
    setMyListings(null);
    setInitialLoading(null);
  }

  const [openScanner, setOpenScanner] = useState(null);

  function openQRScanner(listingID) {
  if(openScanner !== null || listingID === null || listingID === undefined) return;
    setOpenScanner(listingID);
  }

  function closeScanner() {
    setOpenScanner(null)
  }

  function handleNewPurchaseDetails(listingID, purchaseDetails) {
    const listingIndex = myListings.findIndex((listing) => listing._id === listingID);
    if (listingIndex === -1) {
        console.error("Could not find listing in current array of listings.");
        return;
    }

    const newMyListings = [...myListings];

    const updatedListing = {
        ...newMyListings[listingIndex],
        purchaseDetails: purchaseDetails
    };

    newMyListings[listingIndex] = updatedListing;

    setMyListings(newMyListings);
}

  return (
      <section id={styles.wrapper}>
        { viewAuctionData !== null && <AuctionListing listingID={viewAuctionData} closeListing={setViewAuctionData} /> }
        { editAuctionData !== null && <EditAuction listingID={editAuctionData} refreshListings={refreshListings} closeEditor={() => setEditAuctionData(null)}  /> }
        { createAuction && <CreateAuction setCreateAuction={setCreateAuction} refreshListings={refreshListings} /> }
        { openScanner !== null && <></> }


        { isLoading() === true && <section id={styles.loading}><PulseLoader size={30} color='#154734' /></section> }
        { isLoading() === false && 
          <section id={styles.container}>
            <CreateAuctionCard setCreateAuction={setCreateAuction} />
            {
              myListings.map((listing, index) => {
                return <AuctionCard key={index} listing={listing} setViewAuctionData={setViewAuctionData} setEditAuctionData={setEditAuctionData} openQRScanner={openQRScanner} handleNewPurchaseDetails={handleNewPurchaseDetails} />
              })
            }
          </section>
        }

      </section>
  )
}

const AuctionCard = ({ listing, setViewAuctionData, setEditAuctionData, handleNewPurchaseDetails }) => {

  const router = useRouter();
  const { data: session, status } = useSession();
  const { socket, auctionSocketConnected, auctionSocket } = useSocket();

  const [bids, setBids] = useState(listing.bids.length > 0 ? listing.bids.sort((a, b) => b.bid - a.bid) : []);

  const [coverLoaded, setCoverLoaded] = useState(false);
  const getCover = listing.images.findIndex((images) => images.position === 1);

  const listingID = listing._id;

  const acceptingPayments = listing.acceptPayments.enabled;

  function handleIncomingBid(data) {
    const incomingAuctionID = data.auctionID;
    if(incomingAuctionID !== listingID) return;
    const username = data.username;
    const bid = data.bid;

    const newBid = { auctionID, username, bid };
    const updatedBids = [...bids, newBid];

    updatedBids.sort((a, b) => b.bid - a.bid);

    setBids(updatedBids);
  }

  const [auctionState, setAuctionState] = useState(null);
  
  useEffect(() => {
    if(!auctionSocketConnected || !auctionSocket) return;
    if(!auctionState) return;
    if(auctionState === 'Auction Closed') return;

      const auctionRoomID = listingID;

      auctionSocket.emit('join-auction-room', { roomID: auctionRoomID });

    return () => {
      auctionSocket.emit('leave-auction-room', { roomID: auctionRoomID });
    };
  }, [auctionSocketConnected, auctionSocket, auctionState]);

  useEffect(() => {
    if(!auctionSocketConnected || !auctionSocket) return;
    if(!auctionState) return;
    if(auctionState === 'Auction Closed') return;
    auctionSocket.on('incomingBid', handleIncomingBid);

    return () => {
      auctionSocket.off('incomingBid');
    };
  }, [auctionSocketConnected, auctionSocket, auctionState])

  function getHighestBid() {
    if(bids.length === 0) return { bid: 0.00 }
    const sortedBidsArray = [...bids].sort((a, b) => b.bid - a.bid);
    if(!isEqual(sortedBidsArray, bids)) {
      setBids(sortedBidsArray);
    }

    return sortedBidsArray[0]
  }

  const [loadingBids, setLoadingBids] = useState(false);

  async function getFinalBidArray() {
    if(loadingBids) return;

    setLoadingBids(true);

    const getAuctionBids = await axios.post(`${window.location.origin}/api/auctionHub/helpers/getAuctionBids`, {
      auctionID: listingID,
    }).catch((error) => {
      errorMsg(error?.response?.data?.status || error.toString());
    });

    if (getAuctionBids.status === 200) {
      const result = getAuctionBids.data;
      setBids(result);
    }

    setLoadingBids(false);
  }

  const [pendingHandleMessageOperation, setPendingHandleMessageOperation] = useState(false);
  const [openNewMessage, setOpenNewMessage] = useState(null);

  async function handleMessageBuyerOperation() {
    if(pendingHandleMessageOperation) return;
    if(!session) return;
    if(status !== 'authenticated') return;
    if(bids.length === 0) return;
    if(!getHighestBid().username) return;

    setPendingHandleMessageOperation(true);

    const result = await axios.post(`${window.location.origin}/api/messaging/hasActiveConvo`, {
        requestingUserID: session.user.token.id,
        otherUser: getHighestBid().username,
        convoType: 'Auctions',
        listingID: listingID,
    }).catch((error) => {
        errorMsg(error?.response?.data?.status || error.toString());
        closeProfile();
    })

    if(result && result.status === 200) {
        const data = result.data;

        if(data.hasConvo) {
          handleOpenCurrentConversation(data.convoID);
        } else {
          setOpenNewMessage(true);
        }

    }

    setPendingHandleMessageOperation(false);

  }

  function handleOpenCurrentConversation(convoID) {
    const { query } = router;

    const updatedQuery = { ...query, openConversationID: convoID };

    router.push({ pathname: router.pathname, query: updatedQuery });
  }

  const [pendingSend, setPendingSend] = useState(false);
  const messageRef = useRef(null);

  async function handleSendMessage(e) {
    e.preventDefault();
    if(status === 'loading') return;
    if(!socket) return;
    if(!session) return errorMsg("Please login to message this user.");
    if(status === 'unauthenticated') return errorMsg("Please login to message this user.");
    if(pendingSend === true) return;
    if(!messageRef || !messageRef.current) return;
    const messageText = messageRef.current.value;
    if(messageText.length === 0) return errorMsg("Please enter your message before sending.");
    if(messageText.length > 500) return errorMsg("Message cannot be over 500 characters.")
    
    const senderID = session.user.token.id;
    const sender = session.user.token.username;
    const toUser = getHighestBid().username;
    if(!toUser) return errorMsg("Could not find the buyer, please contact us if the issue persists.");

    const basicConvoData = {
        type: 'Auctions',
        listingID: listingID,
        receiver: toUser,
        sender: sender,
        creationDate: new Date().toISOString()
    }

    setPendingSend(true);

    const result = await axios.post(`${window.location.origin}/api/messaging/create`, {
        conversationData: basicConvoData,
        messageText: messageText,
        senderID: senderID
    }).catch((error) => {
        errorMsg(error?.response?.data?.status || error.toString())
    });

    if(result && result.status === 200) {
        const newConvoData = result.data;

        socket.emit('createNewConversation', newConvoData)

        successMsg("Your message was sent.");

        setOpenNewMessage(false);
    }

    setPendingSend(false);
  }

  const [openStatusBox, setOpenStatusBox] = useState(false);
  const [getStatus, setGetStatus] = useState(null);
  const [pendingStatus, setPendingStatus] = useState(false);

  async function handleSubmitStatus() {
    if(pendingStatus) return;
    if(getStatus === null) return errorMsg("Please select a reason before submitting.");

    /*
        const getRequestingID = req.body.getRequestingID;
        const auctionID = req.body.auctionID;
        const getStatus = req.body.getStatus;
    */

    setPendingStatus(true);

    const result = await axios.post(`${window.location.origin}/api/auctionHub/helpers/submitStatus`, {
      getRequestingID: session.user.token.id,
      auctionID: listingID,
      getStatus: getStatus
    }).catch((error) => {
        errorMsg(error?.response?.data?.status || error.toString())
    });

    if(result && result.status === 200) {
      const purchaseDetailsData = result.data;
      setOpenStatusBox(false);
      setGetStatus(null)
      handleNewPurchaseDetails(listingID, purchaseDetailsData);
      successMsg("Auction status has been updated.");
    }

    setPendingStatus(true);


  }

  function returnSelectedStatusStyle(type) {
    if(getStatus === null) return;
    if(type === getStatus) return { backgroundColor: 'white' }
  }

  function returnAuctionOverlayStatus() {
    if(auctionState !== 'Auction Closed') return;
    
    if(listing.bids.length === 0) return 'NO-WINNER'
    if(listing.purchaseDetails === null) return 'AWAIT'
    if(listing.purchaseDetails.status === 'SOLD') return 'SOLD';
    if(listing.purchaseDetails.status !== ' SOLD') return 'CANCELLED'
  }

  return (
    <div className={styles.card}>

      <div style={{display: openStatusBox ? 'flex' : 'none'}} id={styles.statusBox} >
        <FontAwesomeIcon onClick={() => setOpenStatusBox(false)} icon={faXmark} id={styles.exit} />
        <h1>Completed the transaction?</h1>
        <section>
          <button style={returnSelectedStatusStyle('SOLD')} onClick={() => setGetStatus('SOLD')}>Yes, the winner of this auction received their item(s).</button>
          <button style={returnSelectedStatusStyle('UNSOLD')} onClick={() => setGetStatus('UNSOLD')}>No, the user has not showed up or hasn't responded.</button>
          <button style={returnSelectedStatusStyle('CANCELLATION')} onClick={() => setGetStatus('CANCELLATION')}>Cancellation of transaction via mutual agreement between you and buyer.</button>
        </section>
        <button onClick={handleSubmitStatus} style={{display: getStatus === null ? 'none' : 'flex'}}>{ pendingStatus ? <BarLoader color='white' /> : 'Confirm Now' }</button>
      </div>

      <div style={{display: openNewMessage ? 'flex' : 'none'}} id={styles.quickMessage}>
        <FontAwesomeIcon onClick={() => setOpenNewMessage(false)} icon={faXmark} id={styles.exit} />
        <h1>Chat with {getHighestBid().username}</h1>
        <textarea ref={messageRef} placeholder="Write this user a message..." />
        <button onClick={handleSendMessage}> { pendingSend ? <BarLoader color='#4169E1' /> : <FontAwesomeIcon icon={faPaperPlane} /> } </button>
      </div>

      <section>

        <div style={{display: returnAuctionOverlayStatus() === 'SOLD' ? 'flex' : 'none', backgroundColor: '#207e20e6'}} id={styles.transactionOverlay}>
            <h1>Transaction Complete</h1>
            <FontAwesomeIcon icon={faCheck} id={styles.icon} />
        </div>

        <div style={{display: returnAuctionOverlayStatus() === 'AWAIT' ? 'flex' : 'none', backgroundColor: '#7e7520e6'}} id={styles.transactionOverlay}>
            <h1>Awaiting Transaction</h1>
            <FontAwesomeIcon icon={faPeopleArrows} id={styles.icon} />
        </div>

        <div style={{display: returnAuctionOverlayStatus() === 'CANCELLED' ? 'flex' : 'none', backgroundColor: '#7e2020e6'}} id={styles.transactionOverlay}>
            <h1>Transaction Cancelled</h1>
            <FontAwesomeIcon icon={faCancel} id={styles.icon} />
        </div>

        <div style={{display: returnAuctionOverlayStatus() === 'NO-WINNER' ? 'flex' : 'none', backgroundColor: '#252525e6'}} id={styles.transactionOverlay}>
            <h1>No Winner</h1>
        </div>

        <TimeStampContainer duration={listing.auctionDuration} created={listing.creationDate} handleGetFinalBidsArray={getFinalBidArray} auctionState={auctionState} setAuctionState={setAuctionState} />
        <div style={{display: coverLoaded === false ? 'flex' : 'none'}}> <LoadingSpinner type="pulse" color="#154734" /></div>
        <Image sizes='auto auto' fill src={listing.images[getCover].url} alt={listing.images[getCover].url} onLoadingComplete={() => setCoverLoaded(true)} />
        { acceptingPayments && <FontAwesomeIcon icon={faDollarSign} id={styles.acceptingPaymentsIcon} /> }
      </section>
      { (loadingBids || !auctionState) ?
        <section style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
          <BarLoader color='black' />
        </section>
        :
        <section>
          <div>
            <h1>{listing.title}</h1>
            { auctionState === 'Auction Closed' ? <h2><b>{bids.length === 0 ? 'No Winner' : 'Sold For '}</b>{bids.length > 0 && `$${parseFloat(getHighestBid().bid).toLocaleString()}`}</h2> : <h2><b>Bid</b>: ${bids.length === 0 ? listing.price : parseFloat(getHighestBid().bid.toLocaleString()).toLocaleString()}</h2> }
            <div>
              <section>
                <h1>{listing.views.length}</h1>
                <h2>Views</h2>
              </section>
              <section>
                <h1>{listing.watching.length}</h1>
                <h2>Watchers</h2>
              </section>
              <section>
                <h1>{listing.bids.length}</h1>
                <h2>Bids</h2>
              </section>
            </div>
          </div>

          <div>
            <motion.button id={styles.edit} onClick={() => setEditAuctionData(listingID)}>Edit<FontAwesomeIcon icon={faPencil} id={styles.icon} /></motion.button>
            { auctionState === 'Auction Closed' && bids.length > 0 && listing.purchaseDetails === null && <motion.button onClick={() => setOpenStatusBox(true)} id={styles.settings}><FontAwesomeIcon icon={faPeopleArrows} id={styles.icon} /></motion.button> }
            { auctionState === 'Auction Closed' && returnAuctionOverlayStatus() !== 'CANCELLED' && returnAuctionOverlayStatus() !== 'NO-WINNER' && <motion.button onClick={handleMessageBuyerOperation} id={styles.message}> { pendingHandleMessageOperation ? <PuffLoader size={22} color='white' /> : <FontAwesomeIcon icon={faMessage} id={styles.icon} /> }  </motion.button> }
            <motion.button id={styles.view} onClick={() => setViewAuctionData(listingID)}><FontAwesomeIcon icon={faEye} id={styles.icon} /></motion.button>
          </div>

        </section>
      }

    </div>
  )
}

const TimeStampContainer = ({ duration, created, handleGetFinalBidsArray, auctionState, setAuctionState }) => {
  const [timeStamps, setTimeStamps] = useState(null);

  useEffect(() => {
    if(duration === null || duration === undefined || created === null || created === undefined) return;

    const countdownInterval = setInterval(() => {

      const timestamp = getTimeStamp(duration, created);

      if(timestamp === 'Auction Closed' || timestamp === 'Calculating winner...') {
        if(auctionState !== timestamp) {
          setAuctionState(timestamp);
        }
      } else {
        if(auctionState !== 'Counting Down') {
          setAuctionState("Counting Down")
        }
      }

      if(timestamp === 'Auction Closed') {
        closeCountdown();
        handleGetFinalBidsArray();
        setTimeStamps("Auction Closed");
        return;
      }

      setTimeStamps(timestamp);
    }, 100);

    function closeCountdown() {
      clearInterval(countdownInterval);
    }

    return () => {
      clearInterval(countdownInterval)
    }

  }, [])

  return timeStamps !== null && <h1>{timeStamps}</h1>;
}

function getTimeStamp(duration, created) {

  const durDays = parseInt(duration);

  const ending_date = new Date(Date.parse(created));
  ending_date.setDate(ending_date.getDate() + durDays);

  const current_day = new Date();

  const total = ending_date - Date.parse(current_day); // Future ending date is subtracting by current date to get proper values
  
  const seconds = Math.floor( (total/1000) % 60 );
  const minutes = Math.floor( (total/1000/60) % 60 );
  const hours = Math.floor( (total/(1000*60*60)) % 24 );
  const days = Math.floor( total/(1000*60*60*24) );

  var returnSeconds;
  var returnMinutes;
  var returnHours;
  var returnDays;

  if(seconds < 0) {
    returnSeconds = 0;
  } else {
    returnSeconds = seconds;
  }

  if(minutes < 0) {
    returnMinutes = 0;
  } else {
    returnMinutes = minutes;
  }

  if(hours < 0) {
    returnHours = 0;
  } else {
    returnHours = hours;
  }

  if(days < 0) {
    returnDays = 0;
  } else {
    returnDays = days;
  }

  var state = null;

  if(seconds <= 0 && total >= -15000) {
    state = "Calculating winner..."
  }

  if(total < -15000) {
    state = "Auction Closed"
  }

  if(total > 0) {
    state = `${returnDays}d : ${returnHours}hr : ${returnMinutes}m : ${returnSeconds}s`
  }

  return state
}

const CreateAuctionCard = ({ setCreateAuction }) => {
  
  return (
    <div id={styles.createCard} onClick={() => setCreateAuction(true)}>
      <FontAwesomeIcon icon={faSquarePlus} id={styles.icon} />
      <h1>Create Auction</h1>
    </div>
  )
}